import { defineMessages } from 'react-intl';
import {
  OPERATOR_TYPE_IS_BLANK,
  OPERATOR_TYPE_IS_NOT_BLANK,
  OPERATOR_TYPE_EQUALS,
  OPERATOR_TYPE_NOT_EQUALS,
  OPERATOR_TYPE_STARTS_WITH,
  OPERATOR_TYPE_DOES_NOT_START_WITH,
  OPERATOR_TYPE_ENDS_WITH,
  OPERATOR_TYPE_DOES_NOT_END_WITH,
  OPERATOR_TYPE_CONTAINS,
  OPERATOR_TYPE_DOES_NOT_CONTAIN,
  OPERATOR_TYPE_INCLUDES,
  OPERATOR_TYPE_DOES_NOT_INCLUDE,
  OPERATOR_TYPE_VALUE_ARE_EMPTY,
  OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY,
  OPERATOR_TYPE_UNDEFINED,
  OPERATOR_TYPE_IS_UNKNOWN,
  OPERATOR_TYPE_SHORT_EQUALS,
  OPERATOR_TYPE_SHORT_NOT_EQUALS,
  OPERATOR_TYPE_GREATER_THAN,
  OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_LESS_THAN,
  OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_CURRENT_DATE,
  OPERATOR_TYPE_WITHIN_PAST_X_DAYS,
  OPERATOR_TYPE_WITHIN_NEXT_X_DAYS,
  OPERATOR_TYPE_BEFORE_X_DAYS,
  OPERATOR_TYPE_AFTER_X_DAYS,
  OPERATOR_TYPE_ON_OR_AFTER,
  OPERATOR_TYPE_ON_OR_BEFORE,
  OPERATOR_TYPE_VALUE_EQUALS_TRUE,
  OPERATOR_TYPE_VALUE_EQUALS_FALSE,
  OPERATOR_TYPE_SHIPPING_MY_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT,
  OPERATOR_TYPE_TIME_AT_OR_AFTER,
  OPERATOR_TYPE_TIME_AT_OR_BEFORE,
} from '../filter-operator-type';

const messages = defineMessages({
  typeIsBlank: {
    description: 'Filter editor operator value is blank',
    defaultMessage: 'Is Blank',
    id: 'k+xls+',
  },
  typeIsNotBlank: {
    description: 'Filter editor operator value is not blank',
    defaultMessage: 'Is Not Blank',
    id: 'hAZlN9',
  },
  typeEquals: {
    description: 'Filter editor operator value equals',
    defaultMessage: 'Equals...',
    id: '0Rpaoi',
  },
  typeNotEquals: {
    description: 'Filter editor operator value not equals',
    defaultMessage: 'Does not Equal...',
    id: 'lvGpeK',
  },
  typeStartWith: {
    description: 'Filter editor operator value starts with',
    defaultMessage: 'Starts with...',
    id: 'LvB+Hz',
  },
  typeDoesntStartWith: {
    description: 'Filter editor operator value doesnt start with',
    defaultMessage: 'Does not Start with...',
    id: '3t4EGl',
  },
  typeEndsWith: {
    description: 'Filter editor operator value ends with',
    defaultMessage: 'Ends with...',
    id: 'sEq8ga',
  },
  typeDoesntEndWith: {
    description: 'Filter editor operator value doesnt end with',
    defaultMessage: 'Does not End with...',
    id: 'N/I7V6',
  },
  typeContains: {
    description: 'Filter editor operator value contains',
    defaultMessage: 'Contains...',
    id: 'PrhTV1',
  },
  typeDoesntContain: {
    description: 'Filter editor operator value doesnt contain',
    defaultMessage: 'Does not Contain...',
    id: 'FY1mgh',
  },
  typeIncludes: {
    description: 'Filter editor operator value includes',
    defaultMessage: 'Includes...',
    id: 'onchvs',
  },
  typeDoesntInclude: {
    description: 'Filter editor operator value doesnt include',
    defaultMessage: 'Do not Include...',
    id: 'lYMgy/',
  },
  typeAreEmpty: {
    description: 'Filter editor operator value is empty',
    defaultMessage: 'Are Empty',
    id: 'Gfhc9H',
  },
  typeAreNotEmpty: {
    description: 'Filter editor operator value is not empty',
    defaultMessage: 'Are Not Empty',
    id: 'yKSpPa',
  },
  typeUndefined: {
    description: 'Filter editor operator type could not be determined',
    defaultMessage: 'Operator type could not be found',
    id: '13DPHP',
  },
  typeIsUnknown: {
    description: 'Filter editor operator type is unknown',
    defaultMessage: 'Is Unknown',
    id: '4Z83wK',
  },
  typeGreaterThan: {
    description: 'Filter editor operator type greater than',
    defaultMessage: 'Is Greater Than...',
    id: 'Xg+P5S',
  },
  typeGreaterThanOrEqualTo: {
    description: 'Filter editor operator type greater than or equal to',
    defaultMessage: 'Is Greater Than or Equal To...',
    id: 'Cf5R8o',
  },
  typeLessThan: {
    description: 'Filter editor operator type less than',
    defaultMessage: 'Less Than...',
    id: 'QUyQSW',
  },
  typeLessThanEqualTo: {
    description: 'Filter editor operator type less than or equal to',
    defaultMessage: 'Less Than or Equal To...',
    id: 'h3ZFPH',
  },
  typeCurrentDate: {
    description: 'Filter editor operator type curent date',
    defaultMessage: 'Equals the current date',
    id: 'Z8FVpj',
  },
  typeWithinPastDays: {
    description: 'Filter editor operator type within past X days',
    defaultMessage: 'Within the past X days',
    id: 'jJ4HU7',
  },
  typeWithinNextDays: {
    description: 'Filter editor operator type within next X days',
    defaultMessage: 'Within the next X days',
    id: 'mCIOyE',
  },
  typeBeforeDays: {
    description: 'Filter editor operator type before X days',
    defaultMessage: 'X days ago or more',
    id: 'FcyUF0',
  },
  typeAfterDays: {
    description: 'Filter editor operator type after X days',
    defaultMessage: 'X days ahead or more',
    id: 'ReR9x5',
  },
  typeOnOrAfter: {
    description: 'Filter editor operator type on or after',
    defaultMessage: 'Is on or after...',
    id: 'gH9dPo',
  },
  typeOnOrBefore: {
    description: 'Filter editor operator type on or before',
    defaultMessage: 'Is on or before...',
    id: 'K9i1KL',
  },
  typeIsTrue: {
    description: 'Filter editor operator type is true',
    defaultMessage: 'True',
    id: 'XfuvfT',
  },
  typeIsFalse: {
    description: 'Filter editor operator type is false',
    defaultMessage: 'False',
    id: 'HIQWA6',
  },
  typeIsMyAccount: {
    description: 'Filter editor operator My Account',
    defaultMessage: 'My Account...',
    id: 'rf/jDi',
  },
  typeIsRecipientAccount: {
    description: 'Filter editor operator Recipient Account',
    defaultMessage: 'Recipients...',
    id: 'vZPMRC',
  },
  typeIsThirdPartyAccount: {
    description: 'Filter editor operator Third-party Account',
    defaultMessage: 'Third Parties...',
    id: 'NOHGAk',
  },
  typeTimeAtOrAfter: {
    description: 'Filter editor operator time is at or after',
    defaultMessage: 'Is on or after...',
    id: 'tmEY0C',
  },
  typeTimeAtOrBefore: {
    description: 'Filter editor operator time is at or before',
    defaultMessage: 'Is on or before...',
    id: 'qpjGj3',
  },
});

const typeToMessageMap = {
  [OPERATOR_TYPE_IS_BLANK]: messages.typeIsBlank,
  [OPERATOR_TYPE_IS_NOT_BLANK]: messages.typeIsNotBlank,
  [OPERATOR_TYPE_EQUALS]: messages.typeEquals,
  [OPERATOR_TYPE_NOT_EQUALS]: messages.typeNotEquals,
  [OPERATOR_TYPE_STARTS_WITH]: messages.typeStartWith,
  [OPERATOR_TYPE_DOES_NOT_START_WITH]: messages.typeDoesntStartWith,
  [OPERATOR_TYPE_ENDS_WITH]: messages.typeEndsWith,
  [OPERATOR_TYPE_DOES_NOT_END_WITH]: messages.typeDoesntEndWith,
  [OPERATOR_TYPE_CONTAINS]: messages.typeContains,
  [OPERATOR_TYPE_DOES_NOT_CONTAIN]: messages.typeDoesntContain,
  [OPERATOR_TYPE_INCLUDES]: messages.typeIncludes,
  [OPERATOR_TYPE_DOES_NOT_INCLUDE]: messages.typeDoesntInclude,
  [OPERATOR_TYPE_VALUE_ARE_EMPTY]: messages.typeAreEmpty,
  [OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY]: messages.typeAreNotEmpty,
  [OPERATOR_TYPE_UNDEFINED]: messages.typeUndefined,
  [OPERATOR_TYPE_IS_UNKNOWN]: messages.typeIsUnknown,
  [OPERATOR_TYPE_SHORT_EQUALS]: messages.typeEquals,
  [OPERATOR_TYPE_SHORT_NOT_EQUALS]: messages.typeNotEquals,
  [OPERATOR_TYPE_GREATER_THAN]: messages.typeGreaterThan,
  [OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO]: messages.typeGreaterThanOrEqualTo,
  [OPERATOR_TYPE_LESS_THAN]: messages.typeLessThan,
  [OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO]: messages.typeLessThanEqualTo,
  [OPERATOR_TYPE_CURRENT_DATE]: messages.typeCurrentDate,
  [OPERATOR_TYPE_WITHIN_PAST_X_DAYS]: messages.typeWithinPastDays,
  [OPERATOR_TYPE_WITHIN_NEXT_X_DAYS]: messages.typeWithinNextDays,
  [OPERATOR_TYPE_BEFORE_X_DAYS]: messages.typeBeforeDays,
  [OPERATOR_TYPE_AFTER_X_DAYS]: messages.typeAfterDays,
  [OPERATOR_TYPE_ON_OR_AFTER]: messages.typeOnOrAfter,
  [OPERATOR_TYPE_ON_OR_BEFORE]: messages.typeOnOrBefore,
  [OPERATOR_TYPE_VALUE_EQUALS_TRUE]: messages.typeIsTrue,
  [OPERATOR_TYPE_VALUE_EQUALS_FALSE]: messages.typeIsFalse,
  [OPERATOR_TYPE_SHIPPING_MY_ACCOUNT]: messages.typeIsMyAccount,
  [OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT]: messages.typeIsRecipientAccount,
  [OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT]: messages.typeIsThirdPartyAccount,
  [OPERATOR_TYPE_TIME_AT_OR_AFTER]: messages.typeTimeAtOrAfter,
  [OPERATOR_TYPE_TIME_AT_OR_BEFORE]: messages.typeTimeAtOrBefore,
};

export const operatorTypeNameFromOperatorType = (operatorType) => {
  return typeToMessageMap[operatorType];
};
